<div class="bciti-dialog__header">
  <div class="bciti-dialog__title">{{ data.translatedValues.title }}</div>
  <button class="bciti-dialog__close-button" (click)="close()">
    <span class="icon icon-close"></span>
  </button>
</div>
<div class="bciti-dialog__content content">
  <div class="schedule-infos">{{ data.translatedValues.infos }}</div>
  <form [formGroup]="schedulesDialogForm">
    <!-- Custom Schedule -->
    <div *ngIf="isCustom" class="custom-schedule-form">
      <div class="custom-schedule-form__names" formGroupName="name">
        <app-form-input
          *ngFor="let language of data.langs"
          [lang]="language"
          [label]="'pages.services-state.dialogs.service-schedule-dialog.name.' + language + '.label' | translate"
          [formControlName]="language"
          [placeholder]="'pages.services-state.dialogs.service-schedule-dialog.name.' + language + '.placeholder' | translate"
        >
          <app-form-error *ngIf="name.get(language).touched && name.get(language).hasError('required')">
            {{ 'pages.services-state.dialogs.service-schedule-dialog.name.errors.required' | translate }}
          </app-form-error>
        </app-form-input>
      </div>
      <div class="custom-schedule-form__date">
        <app-form-datepicker
          *ngIf="from"
          [label]="'pages.services-state.dialogs.service-schedule-dialog.startDate.label' | translate"
          formControlName="from"
          [large]="true"
          [min]="startDateMin"
          (change)="fromDateChange($event)"
        >
          <app-form-error *ngIf="from.touched && from.hasError('required')">
            {{ 'pages.services-state.dialogs.service-schedule-dialog.startDate.errors.required' | translate }}
          </app-form-error>
        </app-form-datepicker>
      </div>
      <div class="custom-schedule-form__date">
        <app-form-datepicker
          *ngIf="to"
          [label]="'pages.services-state.dialogs.service-schedule-dialog.endDate.label' | translate"
          formControlName="to"
          [large]="true"
          [min]="endDateMin"
          (change)="toDateChange($event)"
        >
          <app-form-error *ngIf="to.touched && to.hasError('required')">
            {{ 'pages.services-state.dialogs.service-schedule-dialog.endDate.errors.required' | translate }}
          </app-form-error>
        </app-form-datepicker>
      </div>
    </div>

    <!-- Schedules -->
    <div formGroupName="schedule">
      <ng-container *ngFor="let day of days" >
        <div *ngIf="getDayFormArray(day)" class="schedule" [class.has-interval]="(getDayFormArray(day).controls).length > 0">
          <div class="schedule__day">
            {{ 'pages.services-state.configuration.days-slice.' + day | translate }}
          </div>
          <div class="schedule__intervals" [formArrayName]="day">
            <div *ngFor="let control of getDayFormArray(day).controls; let i = index">
              <app-service-state-schedule-interval [class.large-timeInput]="is12HourFormat" [timeForm]="getDayFormArray(day).at(i)" [closeable]="true"
                (cancelCreate)="handleRemoveInterval(day, i)"
                (toTimeChanged)="handleToTimeChange(i)">
              </app-service-state-schedule-interval>
            </div>
            <div *ngIf="!getDayFormArray(day) || (getDayFormArray(day).controls).length === 0" class="schedule__closed" [ngStyle]="{ 'color': data?.nonAvailableStatus?.color }">
              {{ data?.nonAvailableStatus?.name[currentLang] }}
            </div>
            <div class="schedule__actions" *ngIf="showAddIntervalButton(day)">
              <button class="bciti-link" (click)="handleAddInterval(day)">
                {{ 'pages.services-state.dialogs.service-schedule-dialog.actions.addInterval' | translate }}
              </button>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </form>
</div>
<footer class="bciti-dialog__footer">
  <button (click)="close()" class="bciti-button bciti-button--lightblue-inversed">
    {{ 'common.cancel' | translate }}
  </button>
  <button (click)="saveSchedule()" class="bciti-button bciti-button--blue">
    {{ 'common.save' | translate }}
  </button>
</footer>